<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('keepAlive.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <p>
                {{ $t('keepAlive.desc') }}
            </p>
            <van-tabs v-model="activeName"
                      title-active-color="var(--text-color-1)"
                      title-inactive-color="var(--text-color-3)"
                      line-height="2"
                      color="var(--text-color-1)"
                      @click="change"
            >
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[0]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[1]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[2]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[3]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[4]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[5]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[6]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[7]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[8]') }}</div>
                    </template>
                </van-tab>
                <van-tab>
                    <template #title>
                        <div class="title">{{ $t('keepAlive.tabArr[9]') }}</div>
                    </template>
                </van-tab>
            </van-tabs>
            <div v-if="activeName == 0">
                <h4>{{ $t('keepAlive.xiaomi.p0') }}</h4>
                <h5>{{ $t('keepAlive.xiaomi.p1') }}</h5>
                <p>{{ $t('keepAlive.xiaomi.p2') }}</p>
                <h5>{{ $t('keepAlive.xiaomi.p3') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/1${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p4') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/2${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p7') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/5${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p8') }}</h5>
                <p>{{ $t('keepAlive.xiaomi.p9') }}</p>
                <h5>{{ $t('keepAlive.xiaomi.p10') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/1${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p11') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/2${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p12') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p13') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/xiaomi/9${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.xiaomi.p14') }}</h5>
                <p>{{ $t('keepAlive.xiaomi.p15') }}</p>
                <p>{{ $t('keepAlive.xiaomi.p16') }}</p>
                <div class="img-box">
                    <img class="swiper-img" src="@/assets/theme/light/desc/02keepAlive/xiaomi/10.png">
                </div>
            </div>
            <div v-if="activeName == 1">
                <h4>{{ $t('keepAlive.huawei.p0') }}</h4>
                <h5>{{ $t('keepAlive.huawei.p1') }}</h5>
                <p>{{ $t('keepAlive.huawei.p2') }}</p>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/1.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/2.png`)">
                </div>
                <h5>{{ $t('keepAlive.huawei.p3') }}</h5>
                <p>{{ $t('keepAlive.huawei.p4') }}</p>
                <h5>{{ $t('keepAlive.huawei.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.huawei.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.huawei.p7') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/5${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.huawei.p8') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/6${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.huawei.p9') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/7${l}.png`)">
                </div>
            </div>
            <div v-if="activeName == 2">
                <h4>{{ $t('keepAlive.vivo.p0') }}</h4>
                <h5>{{ $t('keepAlive.vivo.p1') }}</h5>
                <p>{{ $t('keepAlive.vivo.p2') }}</p>
                <h5>{{ $t('keepAlive.vivo.p3') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/vivo/1${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.vivo.p4') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/vivo/2${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.vivo.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/vivo/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.vivo.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/vivo/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.vivo.p7') }}</h5>
                <p>{{ $t('keepAlive.vivo.p80') }}</p>
                <p>{{ $t('keepAlive.vivo.p8') }}</p>
                <h5>{{ $t('keepAlive.vivo.p9') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/vivo/5${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.vivo.p10') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/vivo/6${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.vivo.p11') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/vivo/7${l}.png`)">
                </div>
            </div>
            <div v-if="activeName == 3">
                <h4>{{ $t('keepAlive.oppo.p0') }}</h4>
                <h5>{{ $t('keepAlive.oppo.p1') }}</h5>
                <p>{{ $t('keepAlive.oppo.p2') }}</p>
                <h5>{{ $t('keepAlive.oppo.p3') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/1${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.oppo.p4') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/2${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.oppo.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.oppo.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.oppo.p7') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/5${l}.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/6${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.oppo.p8') }}</h5>
                <p>{{ $t('keepAlive.oppo.p9') }}</p>
                <h5>{{ $t('keepAlive.oppo.p10') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/7${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.oppo.p11') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/8${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.oppo.p12') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/9${l}.png`)">
                </div>
            </div>
            <div v-if="activeName == 4">
                <h4>{{ $t('keepAlive.yijia.p0') }}</h4>
                <h5>{{ $t('keepAlive.yijia.p1') }}</h5>
                <p>{{ $t('keepAlive.yijia.p2') }}</p>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/1${l}.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/2${l}.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.yijia.p3') }}</h5>
                <p>{{ $t('keepAlive.yijia.p4') }}</p>
                <h5>{{ $t('keepAlive.yijia.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.yijia.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/5${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.yijia.p7') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/6${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.yijia.p8') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/7${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.yijia.p9') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/8${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.yijia.p10') }}</h5>
                <p>{{ $t('keepAlive.yijia.p11') }}</p>
                <h5>{{ $t('keepAlive.yijia.p12') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/7${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.yijia.p13') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/8${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.yijia.p14') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/9${l}.png`)">
                </div>
            </div>
            <div v-if="activeName == 5">
                <h4>{{ $t('keepAlive.realme.p0') }}</h4>
                <h5>{{ $t('keepAlive.realme.p1') }}</h5>
                <p>{{ $t('keepAlive.realme.p2') }}</p>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/1${l}.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/2${l}.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.realme.p3') }}</h5>
                <p>{{ $t('keepAlive.realme.p4') }}</p>
                <h5>{{ $t('keepAlive.realme.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.realme.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/5${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.realme.p7') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/6${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.realme.p8') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/7${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.realme.p9') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/yijia/8${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.realme.p10') }}</h5>
                <p>{{ $t('keepAlive.realme.p11') }}</p>
                <h5>{{ $t('keepAlive.realme.p12') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/7${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.realme.p13') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/8${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.realme.p14') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/oppo/9${l}.png`)">
                </div>
            </div>
            <div v-if="activeName == 6">
                <h4>{{ $t('keepAlive.rongyao.p0') }}</h4>
                <h5>{{ $t('keepAlive.rongyao.p1') }}</h5>
                <p>{{ $t('keepAlive.rongyao.p2') }}</p>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/1.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/2.png`)">
                </div>
                <h5>{{ $t('keepAlive.rongyao.p3') }}</h5>
                <p>{{ $t('keepAlive.rongyao.p4') }}</p>
                <h5>{{ $t('keepAlive.rongyao.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.rongyao.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.rongyao.p7') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/5${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.rongyao.p8') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/6${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.rongyao.p9') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/huawei/7${l}.png`)">
                </div>
            </div>
            <div v-if="activeName == 7">
                <h4>{{ $t('keepAlive.lianxiang.p0') }}</h4>
                <h5>{{ $t('keepAlive.lianxiang.p1') }}</h5>
                <p>{{ $t('keepAlive.lianxiang.p2') }}</p>
                <h5>{{ $t('keepAlive.lianxiang.p3') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/1${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p4') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/2${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p7') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/5${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p8') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/6${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p9') }}</h5>
                <p>{{ $t('keepAlive.lianxiang.p10') }}</p>
                <h5>{{ $t('keepAlive.lianxiang.p11') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/7${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p12') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/8${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p13') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/9${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p14') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/10${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p15') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/11${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.lianxiang.p16') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/lianxiang/12${l}.png`)">
                </div>
            </div>
            <div v-if="activeName == 8">
                <h4>{{ $t('keepAlive.meizu.p0') }}</h4>
                <h5>{{ $t('keepAlive.meizu.p1') }}</h5>
                <p>{{ $t('keepAlive.meizu.p2') }}</p>
                <h5>{{ $t('keepAlive.meizu.p3') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/meizu/1${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.meizu.p4') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/meizu/2${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.meizu.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/meizu/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.meizu.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/meizu/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.meizu.p7') }}</h5>
                <p>{{ $t('keepAlive.meizu.p8') }}</p>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/meizu/5.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/meizu/6.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/meizu/7.png`)">
                </div>
            </div>
            <div v-if="activeName == 9">
                <h4>{{ $t('keepAlive.sanxing.p0') }}</h4>
                <h5>{{ $t('keepAlive.sanxing.p1') }}</h5>
                <p>{{ $t('keepAlive.sanxing.p2') }}</p>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/1${l}.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/2${l}.png`)">
                </div>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/3${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p3') }}</h5>
                <p>{{ $t('keepAlive.sanxing.p4') }}</p>
                <h5>{{ $t('keepAlive.sanxing.p5') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/4${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p6') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/5${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p7') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/6${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p8') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/7${l}.png`)">
                </div>
                <h4>{{ $t('keepAlive.sanxing.p9') }}</h4>
                <p>{{ $t('keepAlive.sanxing.p10') }}</p>
                <h5>{{ $t('keepAlive.sanxing.p11') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/8${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p12') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/9${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p13') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/10${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p14') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/11${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p15') }}</h5>
                <div class="img-box">
                    <img class="swiper-img" :src="require(`@/assets/theme/light/desc/02keepAlive/sanxing/12${l}.png`)">
                </div>
                <h5>{{ $t('keepAlive.sanxing.p16') }}</h5>
                <a class="a-toSamset" @click="toSamset">{{ $t('keepAlive.sanxing.p17') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable} from '@/utils/comment'
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'dailyActive',
    data() {
        return {
            activeName: 0,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            // theme: 'light',
            l: getQueryVariable("lang") == 'en' ? "en" : "",
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        toSamset() {
            this.$router.push({
                name: 'samSet',
                query: {
                    lang: this.$i18n.locale
                }
            })
        }
    }
}
</script>

<style scoped>

.content {
    margin: 0 10px;
    color: var(--text-color-1);
    font-size: 16px;
}

p {
    text-indent: 2em;
}

.img-box {
    text-align: center;
}

.swiper-img {
    width: 90%;
}

.a-toSamset {
    font-size: 14px;
    text-decoration-line: underline;
}

/deep/ .van-tab {
    font-size: 12px;
    letter-spacing: 2px;
}

/deep/ .van-tabs__nav {
    background-color: var(--bg-color-1);
}

/deep/ .van-tabs--line .van-tabs__wrap {
    height: auto;
}

/deep/ .van-tabs__line {
    bottom: 10px;
    width: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/desc/02keepAlive.vue